import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: () => fetchPages<RoleResponse>('roles', config.ws.roles.all, 'GET'),
  create: (body: RoleCreationRequest) => ws<RoleResponse>(config.ws.roles.create, 'POST', body),
  update: (roleId: string, body: RoleUpdateRequest) =>
    ws<RoleResponse>(config.ws.roles.update.replace('{roleId}', roleId), 'PUT', body),
  delete: (roleId: string) => ws<void>(config.ws.roles.delete.replace('{roleId}', roleId), 'DELETE'),
  scopes: (typeUtilisateur: TypeUtilisateurRole) =>
    ws<ScopesList>(`${config.ws.roles.scopes}?typeUtilisateur=${typeUtilisateur}`, 'GET'),
}

export default api
